import React from "react";

const WhoWeAre = () =>{
    return(
    <>
    <div id="who-we-are">
    <div className="container">
      <div className="row d-flex align-items-center">
        <div className="col-lg-5">
          <div className="whoweare-item">
            <div className="whoweare-left">
              <h5 className="head-after">
                Welcome to <span className="theme-text-default">PerennialLink</span>
              </h5>
              <h1>
                <span>Unwavering</span> Support When You Need It Most.
              </h1>
              <p>
              We are committed to providing our customers with the best possible service 
              and products. We are constantly striving to improve our offerings and exceed your expectations.
              </p>
              <a
                href="#lu"
                className="btn theme-btn-default btn-icon"
              >
                <span>Read More</span>
              </a>
            </div>
          </div>
        </div>
        <div className="col-lg-4">
          <div className="whoweare-item pb-60px">
            <div className="whoweare-center">
              <div className="whoweare-center-img1">
                <img src="assets/images/logis3.jpg" alt="" />
                </div>
              {/* video */}
              <div id="video" className="modal fade" role="dialog">
                <div className="modal-dialog modal-lg">
                  <div className="modal-content">
                    <div className="modal-header">
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                      >
                        ×
                      </button>
                    </div>
                   </div>
                </div>
              </div>
              <div className="whoweare-center-img2">
                <img src="assets/images/planning2.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-3">
          <div className="whoweare-item">
            <div className="whoweare-right">
              <div className="card">
                <h6>
                  <i className="flaticon-checked theme-text-default" />{" "}
                  We help improve <b>Efficiency</b>
                </h6>
              </div>
              <div className="card">
                <h6>
                  <i className="flaticon-checked theme-text-default" />{" "}
                  We help reduce <b>Costs</b>
                </h6>
              </div>
              <div className="card">
                <h6>
                  <i className="flaticon-checked theme-text-default" />{" "}
                  Right Product to the <b>right place</b>
                </h6>
              </div>
            </div>
            <div className="whoweare-right-btn">
              <a
                href="#lu"
                className="btn btn-block theme-btn-default-two btn-icon btn-icon-active"
              >
                <span>Explore more</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
    </>
    )
}

export default WhoWeAre;